import { oz } from '@weft/utils';
import { TriggerAnonymousCustomersReportJobParametersSchema, TriggerContractsReportJobParametersSchema, TriggerProductsUsageReportJobParametersSchema, TriggerUnchargedUsageReportJobParametersSchema } from './trigger-report-job-parameters';
import { TriggerCommitmentUsageReportJobParametersSchema } from './trigger-report-job-parameters/commitment-usage-report';
import { TriggerMonthlyClosureReportJobParametersSchema } from './trigger-report-job-parameters/montly-clouser-report';

export const TriggerReportJobRequestSchema = oz.discriminatedUnion('reportJobType', [
  TriggerCommitmentUsageReportJobParametersSchema,
  TriggerUnchargedUsageReportJobParametersSchema,
  TriggerProductsUsageReportJobParametersSchema,
  TriggerContractsReportJobParametersSchema,
  TriggerAnonymousCustomersReportJobParametersSchema,
  TriggerMonthlyClosureReportJobParametersSchema,
]);

export type TriggerReportJobRequestPayload = oz.TypeOf<typeof TriggerReportJobRequestSchema>;